import React, {useMemo} from 'react';
import {useTranslation} from '../../../hooks/useTranslation';
import {getTextColor} from '../../../utils/ColorHelper';

interface ScaleBand {
  id?: string | number;
  label?: string;
  color?: string;
  displayOrder?: number | null;
}

interface ScaleBandPreviewProps {
  bands: ScaleBand[];
}

const formatTpl = (tpl: string, vars: Record<string, string | number>): string =>
  tpl.replace(/\{(\w+)\}/g, (_, k) => String(vars[k] ?? ''));

const ScaleBandPreview: React.FC<ScaleBandPreviewProps> = ({bands}) => {
  const {t} = useTranslation();

  const ordered = useMemo(() => {
    return [...bands].sort((a, b) => {
      const ao = a.displayOrder ?? Number.MAX_SAFE_INTEGER;
      const bo = b.displayOrder ?? Number.MAX_SAFE_INTEGER;
      return ao - bo;
    });
  }, [bands]);

  if (ordered.length === 0) return null;

  return (
    <div className="gt-ac-preview">
      <div className="gt-ac-preview-track">
        {ordered.map((band, i) => {
          const bg = band.color || '#bcc4d3';
          const fg = getTextColor(bg, '#ffffff', '#394050');
          return (
            <div
              key={band.id ?? `band-${i}`}
              className="gt-ac-preview-band"
              style={{backgroundColor: bg, color: fg}}
            >
              <span className="gt-ac-preview-band-label">{band.label || '—'}</span>
              {band.displayOrder != null && (
                <span className="gt-ac-preview-band-order">#{band.displayOrder}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ScaleBandPreview;
